import { DataProxy } from '@apollo/client';
export const clearBlocksCache = (cache: DataProxy) => {
  //@ts-ignore cache structure is like this only
  const rootQuery = cache.data.data.ROOT_QUERY;
  // //GET_USER_BLOCKS query for Blocks Navigation menu has key "pf-project-blocks"
  if (rootQuery) {
    Object.keys(rootQuery)
      .filter((query) => query.indexOf('pf-project-blocks(') === 0)
      .forEach((query) => {
        delete rootQuery[query];
      });
  }

  //TODO: Need to verify the documentation
  //Apollo stores both in ROOT_QUERY and in $ROOT_QUERY
  // Loop through all the data in our cache
  // And delete any items that start with "$ROOT_QUERY.pf-project-blocks"
  // This empties the cache of all of our $ROOT_QUERY.pf-project-blocks and
  // forces a refetch of the  data.
  //@ts-ignore cache structure is like this only
  Object.keys(cache.data.data).forEach((key) => key.match(/ROOT_QUERY.pf-project-blocks/) && cache.data.delete(key));
};
